module.exports = __webpack_public_path__ + "img/zhongli.823f43ed.webp";